import * as React from "react";
import { useState, useEffect } from "react";
import { useAdminAccountFilterStore } from "src/hooks/admin/adminAccountFilter";
import { useAdminCommonStore } from "src/hooks/admin/adminCommon";
import Helper from "src/support/Helper";
import useReduxState from "src/hooks/useReduxState";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import "react-datepicker/dist/react-datepicker.css";
import { DatePicker, DateRangePicker } from "rsuite";
import { Tooltip } from 'src/component/Tooltip';
import { useReportsStore } from 'src/hooks/admin/reports';
import { __remove, __set } from 'src/store/axios_indicator';
import { useDesignHubStore } from "src/hooks/designHub";
import {
  ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY,
  ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL,
  ADMIN_USER_LAST_LOGIN_DATE_SEARCH_TOOLTIP,
  isAdminUserLastLoginDateSearchEnabled,
  isLastLoginDateSearchType,
  shouldDisableAdminUserLastLoginDate
} from "src/support/AdminLastLoginDateSearch";
import { getForbiddenResponseMessage } from "src/service/forbiddenResponseMessage";

export function SearchReport() {
  const [{orgList, roleList}, {get_organization_detail, get_role_list}, {}] = useAdminCommonStore();
  const [{}, {email_report_list}, {set_reports_list_message}] = useReportsStore();
  const [{ countryList }, { get_country_list }, { }] = useDesignHubStore();
  const showLastLoginDateSearch = isAdminUserLastLoginDateSearchEnabled();

  useEffect(() => {
    get_role_list();
    get_country_list();
  }, [])
  const defaultModel = {
    accountName: "",
    accountNumber: "",
    speedboat: "",
    salesOrg: [],
    isAccountActive: "",
    country: [],
    createdDate: "",

    isUserActive: "",
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    lastLoginDate: ""
  };
  const [searchData, setSearchData] = useState(defaultModel);
  const [{ filter_list }, { }, { set_filter_list }] = useAdminAccountFilterStore();
  const [userListErrAlert, setUserListErrAlert] = useReduxState("", "setUserListErrAlert");
  const [errAlertType, setErrAlertType] = useReduxState("", "setErrAlertType");

  useEffect(() => {
    async function fetchHere() {
      get_organization_detail();
    }
    fetchHere();
  }, []);
  useEffect(() => {
    if (!filter_list || Object.entries(filter_list).length === 0) {
      setSearchData(defaultModel);
    } else {
      const searchingData = { ...defaultModel };

      searchingData.accountName = filter_list?.accountName?.searchKeyword ? filter_list?.accountName?.searchKeyword : '';
      searchingData.accountNumber = filter_list?.accountNumber?.searchKeyword ? filter_list?.accountNumber?.searchKeyword : '';
      searchingData.speedboat = filter_list?.speedboat?.searchKeyword ? filter_list?.speedboat?.searchKeyword : '';
      searchingData.salesOrg = filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr : [];
      searchingData.isAccountActive = filter_list?.accountActive?.searchKeyword ? filter_list?.accountActive?.searchKeyword : '';
      searchingData.country = filter_list?.country?.searchKeywordArr ? filter_list?.country?.searchKeywordArr : [];
      searchingData.createdDate = filter_list?.createdDate?.searchKeyword ? filter_list?.createdDate?.searchKeyword : null;
      searchingData.firstName = filter_list?.userFirstName?.searchKeyword ? filter_list?.userFirstName?.searchKeyword : '';
      searchingData.lastName = filter_list?.userLastName?.searchKeyword ? filter_list?.userLastName?.searchKeyword : '';
      searchingData.isUserActive = filter_list?.userActive?.searchKeyword ? filter_list?.userActive?.searchKeyword : '';
      searchingData.role = filter_list?.role?.searchKeyword ? filter_list?.role?.searchKeyword : '';
      searchingData.email = filter_list?.email?.searchKeyword ? filter_list?.email?.searchKeyword : '';
      searchingData.lastLoginDate = showLastLoginDateSearch && filter_list?.lastLoginDate?.searchKeyword ? filter_list?.lastLoginDate?.searchKeyword : '';
      setSearchData(searchingData);
    }

  }, [filter_list, showLastLoginDateSearch]);

  const onSearch = (e) => {
    e.preventDefault();
    const searchableFieldKeys = [
      "accountName",
      "accountNumber",
      "speedboat",
      "salesOrg",
      "isAccountActive",
      "country",
      "createdDate",
      "isUserActive",
      "firstName",
      "lastName",
      "email",
      "role",
      ...(showLastLoginDateSearch ? [ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY] : [])
    ];
    const isSearchDataEmpty = searchableFieldKeys.every(
      (key) => !Helper.valueIsNotNull(searchData[key])
    );

    if (isSearchDataEmpty) {
      setUserListErrAlert(
        "At least one of the fields (Account Name or Account Number) should have search keywords to display results",
        "danger",
        "searchUser"
      );
      setErrAlertType("danger");
      return;
    }

    const keyToSearchType = {
      accountName: "Account Name",
      accountNumber: "Account Number",
      speedboat: "Speedboat",
      salesOrg: "Sales Org",
      isAccountActive: "Account Active",
      isUserActive: "User Active",
      createdDate: "Created Date",
      firstName: "User First Name",
      lastName: "User Last Name",
      email: "Email",
      country: "Country",
      role: "Role",
      ...(showLastLoginDateSearch ? { [ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY]: ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL } : {})
    };

    const filterList = searchableFieldKeys
      .filter((key) => Helper.valueIsNotNull(searchData[key]))
      .map((key) => {
        const value = searchData[key];
        let val = {
          searchType: keyToSearchType[key]
        };
        switch (key) {
          case 'country':
          case 'salesOrg':
            val['searchKeywordArr'] = value?.map((v) => ({ label: v?.label?.trim(), value: v?.value?.trim() }));
            break;
          default:
            val['searchKeyword'] = value?.trim();
            break;
        }
        return val;
      });

    const toCamelCase = (str) => {
      return str
        ?.toLowerCase()
        ?.replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr?.toUpperCase());
    };

    const filterListObject = filterList?.reduce((acc, curr) => {
      const key = isLastLoginDateSearchType(curr?.searchType)
        ? ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY
        : toCamelCase(curr?.searchType);

      if (key === "salesOrg") {
        acc[key] = {
          searchType: curr?.searchType,
          searchKeywordArr: curr?.searchKeywordArr
        };
      } else if (key === "country") {
        acc[key] = {
          searchType: curr?.searchType,
          searchKeywordArr: curr?.searchKeywordArr
        };
      } else {
        acc[key] = {
          searchType: curr?.searchType,
          searchKeyword: curr?.searchKeyword
        };
      }
      return acc;
    }, {});

    if (!filterListObject.hasOwnProperty('speedboat')) {
      setUserListErrAlert(
        "Please select Speedboat",
        "danger",
        "searchReport"
      );
      setErrAlertType("danger");
      return;
    }
    const accountNumberLength = searchData?.accountNumber?.length;
    if (accountNumberLength && accountNumberLength < 2) {
      setUserListErrAlert(
        "Enter at least 2 characters without zero",
        "danger",
        "searchReport"
      );
      setErrAlertType("danger");
      return;
    }

    if (filterListObject.hasOwnProperty('accountNumber')) {
      if (!/^(?!0+$)[0-9]+$/.test(filterListObject.accountNumber.searchKeyword)) {
        setUserListErrAlert(
          "Enter keyword greater than zero",
          "danger",
          "searchReport"
        );
        setErrAlertType("danger");
        return;
      }
    }
    // Clear Alert
    setUserListErrAlert("");
    setErrAlertType("");
    set_filter_list(filterListObject);
  };

  const sendEmail = async (event) => {
    __set('COMMON_API_CALL');
    event.preventDefault();
    try {
      set_reports_list_message('');
      const res = await email_report_list();
      setUserListErrAlert("File will be sent as an email attachment due to large number of records", 'success', 'addUser');
      setErrAlertType('success');
    } catch (error) {
      set_reports_list_message(getForbiddenResponseMessage(error) || 'Something went wrong');
    } finally {
      __remove('COMMON_API_CALL');
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "accountNumber") {
      const truncatedValue = value.slice(0, 10); // Limit to 10 digits
      setSearchData((prevData) => ({
        ...prevData,
        [name]: truncatedValue
      }));
    } else {
      setSearchData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
  };

  return (
    <>
      <div className="bg-grey2">
        <div className="container">
          <div className="accordion-item ">
            <h2 className="accordion-header" id="searchInput">
              <button
                className="accordion-button"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSearch"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <b className="font-16">Search</b>
              </button>
            </h2>

            <div
              id="collapseSearch"
              className="accordion-collapse collapse in"
              aria-labelledby="searchInput"
              data-parent="#accordionExample"
            >
              <div className="accordion-body p-0">
                <form
                  onSubmit={(e) => {
                    onSearch(e);
                  }}
                >
                  <div className="row bs5 m-t-30 ms-0 me-0 usersearch-container">
                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="accountName">Account Name </label>
                      <input
                        className="ps-2 form-control form-control-sm mb-0"
                        name="accountName"
                        placeholder="Account Name"
                        type="text"
                        value={searchData.accountName}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="accountNumber">Account Number </label>
                      <input
                        className="ps-2 form-control form-control-sm mb-0 hidearrow"
                        name="accountNumber"
                        placeholder="Account Number"
                        type="number"
                        onKeyDown={event => ['e', 'E', '+', '-', '.']?.includes(event.key) && event.preventDefault()}
                        value={searchData.accountNumber}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="speedboat">Speedboat * </label>
                      <select
                        className="form-control form-control-sm"
                        name="speedboat"
                        value={searchData.speedboat || ""}
                        onChange={handleInputChange}
                      >
                        <option value={""}>Select a Speedboat</option>
                        <option value={"Silica"}>Silica</option>
                        <option value={"Abacus"}>Abacus</option>
                        <option value={"EBV"}>EBV</option>
                      </select>
                    </div>
                    <div className="col-sm-12 col-md-3 mb-2 multiselect">
                      <label htmlFor="salesOrg">Sales Org </label>
                      <ReactMultiSelectCheckboxes
                        placeholderButtonLabel="Select Sales Org"
                        style={{ minWidth: "300px" }}
                        value={searchData.salesOrg}
                        options={
                          (orgList &&
                            orgList.length > 0 &&
                            orgList.map((option) => ({
                              value: option,
                              label: option
                            }))) || []
                        }
                        onChange={(selectedOptions) => {
                          handleInputChange({
                            target: {
                              name: "salesOrg",
                              value: selectedOptions
                            }
                          });
                        }}
                      />
                    </div>

                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="isAccountActive">Is Account Active? </label>
                      <select
                        className="form-control form-control-sm"
                        name="isAccountActive"
                        value={searchData.isAccountActive || ""}
                        onChange={handleInputChange}
                      >
                        <option value={""}>Select Yes/No</option>
                        <option value={"Yes"}>Yes</option>
                        <option value={"No"}>No</option>
                      </select>
                    </div>
                    <div className="col-sm-12 col-md-3 mb-2 multiselect">
                      <label htmlFor="country">Country </label>
                      <ReactMultiSelectCheckboxes
                        placeholderButtonLabel="Select Country"
                        style={{ minWidth: "300px" }}
                        value={searchData.country}
                        options={countryList}
                        onChange={(selectedOptions) => {
                          handleInputChange({
                            target: {
                              name: "country",
                              value: selectedOptions,
                            },
                          });
                        }}
                      />
                    </div>
                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="createdDate">Created Date </label>
                      <br />
                      <DateRangePicker
                        format={Helper.getDatepickerFormat()}
                        placeholder="Month DD, YYYY"
                        character=" – "
                        cleanable={false}
                        editable={false}
                        value={searchData.createdDate ? searchData.createdDate?.split(';')?.map(isoDate => new Date(isoDate)) : null}
                        onChange={dates => {
                          if (dates?.length === 2) {
                            const isoDateStringArray = [new Date(dates[0]), new Date(dates[1])].map(date => date?.toISOString())?.join(';')
                            handleInputChange({
                              target: {
                                name: "createdDate",
                                value: isoDateStringArray
                              }
                            })
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div>
                    <div className="row bs5 m-t-30 ms-0 me-0 usersearch-container">
                      <div className="col-sm-12 col-md-3 mb-2">
                        <label htmlFor="isUserActive">Is User Active?
                        </label>
                        <select
                          className="form-control form-control-sm"
                          name="isUserActive"
                          value={searchData.isUserActive || ""}
                          onChange={handleInputChange}
                        >
                          <option value={""}>Select Yes/No</option>
                          <option value={"Yes"}>Yes</option>
                          <option value={"No"}>No</option>
                        </select>
                      </div>
                      <div className="col-sm-12 col-md-3 mb-2">
                        <label htmlFor="firstName">User First Name </label>
                        <input className="ps-2 form-control form-control-sm mb-0" placeholder="First Name" type="text" name="firstName"
                          value={searchData.firstName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-sm-12 col-md-3 mb-2">
                        <label htmlFor="lastName">User Last Name </label>
                        <input className="ps-2 form-control form-control-sm mb-0" placeholder="Last Name" type="text" name="lastName"
                          value={searchData.lastName}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="col-sm-12 col-md-3 mb-2">
                        <label htmlFor="email">Email Address</label>
                        <input className="ps-2 form-control form-control-sm mb-0" placeholder="Email" type="text" name="email"
                          value={searchData.email}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-sm-12 col-md-3 mb-2">
                        <label htmlFor="userRole">User Role</label>
                        <select
                          className="form-control form-control-sm"
                          name="role"
                          value={searchData.role || ""}
                          onChange={handleInputChange}
                        >
                          <option value={""}>Select Role</option>
                          {
                            roleList?.map((role, index) => {
                              return <option key={index} value={role.roleName}>
                                {role.roleName}
                              </option>
                            })
                          }
                        </select>
                      </div>
                      {showLastLoginDateSearch &&
                        <div className="col-sm-12 col-md-3 mb-2">
                          <label htmlFor={ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY}>
                            {ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL}
                            <Tooltip
                              position={'bottom center'}
                              opener={() => (
                                <i
                                  className="fa fa-info-circle ms-1 font-13 text-black-stone font-16"
                                  tabIndex="0"
                                  aria-label={ADMIN_USER_LAST_LOGIN_DATE_SEARCH_TOOLTIP}
                                />
                              )}
                              content={() => ADMIN_USER_LAST_LOGIN_DATE_SEARCH_TOOLTIP}
                            />
                          </label>
                          <DatePicker
                            className="w-100 admin-search-date-picker"
                            format={Helper.getDatepickerFormat()}
                            placeholder="Month DD, YYYY"
                            editable={false}
                            oneTap
                            shouldDisableDate={shouldDisableAdminUserLastLoginDate}
                            value={searchData.lastLoginDate ? new Date(searchData.lastLoginDate) : null}
                            onChange={(value) => {
                              handleInputChange({
                                target: {
                                  name: ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY,
                                  value: value ? new Date(value).toISOString() : ""
                                }
                              });
                            }}
                          />
                        </div>}
                    </div>
                  </div>

                  <div className="row bs5 m-t-20">
                    <div className="col-md-12">
                      <div className="d-flex align-items-center justify-content-end">
                        <span className="me-3">
                          <i className="fa fa-envelope me-1" aria-hidden="true"></i>
                          <a onClick={sendEmail} className="text-decoration-underline">
                            Email Report of All Users
                          </a>
                        </span>
                        <button className="btn btn-secondary bs5">Search</button>
                      </div>

                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
